import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import OkCancelModal from '@/shared/components/OkCancelModal';
import intlShape from '@/shared/utils/intlShape';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import messages from '../taskMessages';
import EnumSelect from '@/shared/components/input/EnumSelect';
import DatePicker from '@/shared/components/input/DatePicker';
import { falseFunc, isBeforeMinimum } from '@/shared/utils/validationHelpers';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import YearSelect from '@/shared/components/input/YearSelect';

export default class ChangeMainTaskFieldModal extends Component {
  state = {
    field: 0,
    selectedTaskStatus: 2,
    deadline: moment.utc().startOf('day'),
    executionDate: moment.utc().startOf('day'),
    referenceType: 1,
    referenceYear: moment
      .utc()
      .startOf('day')
      .year(),
  };

  componentDidMount() {
    this.form = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;

    if (prevProps.show !== show) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(() => ({
        selectedTaskStatus: 2,
      }));
    }
  }

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  taskStatusChanged = status => {
    this.setState({
      selectedTaskStatus: status,
    });
  };
  validate() {
    const {
      selectedTaskStatus,
      field,
      deadline,
      executionDate,
      referenceType,
      referenceYear,
    } = this.state;
    if (field === 0 && isBeforeMinimum(deadline)) return false;
    if (field === 1 && !selectedTaskStatus && selectedTaskStatus !== 0) return false;
    if (field === 2) {
      if (!referenceType) return false;
      if (referenceType === 0 && !moment.isMoment(deadline)) return false;
      if (referenceType === 0 && moment.utc(deadline).year() < 2000) return false;
    }
    if (field === 3 && isBeforeMinimum(executionDate)) return false;

    if (!this.form || !this.form.current) return true;
    return this.form.current.reportValidity();
  }
  onSave = () => {
    const {
      selectedTaskStatus,
      field,
      deadline,
      executionDate,
      referenceType,
      referenceYear,
    } = this.state;
    const { onSave } = this.props;
    if (!this.validate()) return Promise.reject(new Error('invalid form'));

    const parameters = {
      field,
    };
    if (field === 0) {
      parameters.deadline = deadline;
    } else if (field === 1) {
      parameters.status = selectedTaskStatus;
    } else if (field === 2) {
      switch (referenceType) {
        case 1:
          parameters.referenceYear = referenceYear;
          break;
        case 2:
          parameters.referenceYear = 0;
          break;
        case 3:
          parameters.referenceYear = -1;
          break;
        default:
          return Promise.reject();
      }
    } else if (field === 3) {
      parameters.executionDate = executionDate;
    } else {
      return Promise.reject();
    }

    return onSave(parameters);
  };

  onFieldChange = field => {
    this.setState({ field });
  };
  deadlineChanged = input => {
    this.setState({
      deadline: input,
    });
  };
  executionDateChanged = input => {
    this.setState({
      executionDate: input,
    });
  };
  refTypeChanged = e => {
    this.setState({ referenceType: parseInt(e.target.value) });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const {
      selectedTaskStatus,
      field,
      deadline,
      executionDate,
      dateFocused,
      executionDateFocused,
      referenceType,
      referenceYear,
    } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeMainTaskField)}
        show={show}
        onClose={this.closeModal}
        onSave={this.onSave}
      >
        {show && (
          <form ref={this.form}>
            <div className="form-horizontal">
              <div className="form-group">
                <label className="control-label col-sm-3">
                  {intl.formatMessage(messages.Field)}
                </label>
                <div className="col-md-6">
                  <EnumSelect
                    enumType="BatchTaskField"
                    value={field}
                    onChange={this.onFieldChange}
                    orderByLabel
                  />
                </div>
              </div>
              {field === 0 && (
                <div
                  className={classNames('form-group', {
                    'has-error': isBeforeMinimum(deadline),
                  })}
                >
                  <label className="control-label col-sm-3">
                    <FormattedMessage {...messages.Deadline} />
                  </label>
                  <div className="col-md-6">
                    <DatePicker
                      placeholder={intl.formatMessage(messages.Deadline)}
                      date={deadline}
                      onDateChange={this.deadlineChanged}
                      focused={dateFocused}
                      onFocusChange={({ focused }) => this.setState({ dateFocused: focused })}
                      id="taskDeadline"
                      block
                      small
                      isOutsideRange={falseFunc}
                    />
                  </div>
                </div>
              )}
              {field === 3 && (
                <div
                  className={classNames('form-group', {
                    'has-error': isBeforeMinimum(executionDate),
                  })}
                >
                  <label className="control-label col-sm-3">
                    <FormattedMessage {...messages.ExecutionDate} />
                  </label>
                  <div className="col-md-6">
                    <DatePicker
                      placeholder={intl.formatMessage(messages.ExecutionDate)}
                      date={executionDate}
                      onDateChange={this.executionDateChanged}
                      focused={executionDateFocused}
                      onFocusChange={({ focused }) =>
                        this.setState({ executionDateFocused: focused })
                      }
                      id="taskExecutionDate"
                      block
                      small
                      isOutsideRange={falseFunc}
                    />
                  </div>
                </div>
              )}
              {field === 1 && (
                <div className="form-group">
                  <label className="control-label col-sm-3">
                    {intl.formatMessage(messages.TaskStatus)}
                  </label>
                  <div className="col-md-6">
                    <EnumSelect
                      enumType="taskstatus"
                      value={selectedTaskStatus || ''}
                      onChange={this.taskStatusChanged}
                    />
                  </div>
                </div>
              )}
              {field === 2 && (
                <div className="form-group">
                  <label className="control-label col-sm-3">
                    {intl.formatMessage(messages.ReferenceYear)}
                  </label>
                  <div className="col-md-9">
                    <label>
                      <input
                        id="override"
                        type="radio"
                        name="refType"
                        value={1}
                        checked={referenceType === 1}
                        onChange={this.refTypeChanged}
                        defaultChecked
                      />
                      <label htmlFor="override" className="margin5L">
                        {intl.formatMessage(messages.OverrideReferenceYear)}
                      </label>
                      <YearSelect
                        id="referenceYearField"
                        value={referenceYear}
                        required
                        onChange={year => this.setState({ referenceYear: year })}
                        onFocus={() => this.setState({ referenceType: 1 })}
                        className="form-control"
                      />
                    </label>
                    <label>
                      <input
                        id="zero"
                        type="radio"
                        name="refType"
                        value={2}
                        checked={referenceType === 2}
                        onChange={this.refTypeChanged}
                      />
                      <label htmlFor="zero" className="margin5L">
                        {intl.formatMessage(messages.ClearReferenceYear)}
                      </label>
                    </label>
                    <label>
                      <input
                        id="recalc"
                        type="radio"
                        name="refType"
                        value={3}
                        checked={referenceType === 3}
                        onChange={this.refTypeChanged}
                      />
                      <label htmlFor="recalc" className="margin5L">
                        {intl.formatMessage(messages.RecalculateReferenceYear)}
                      </label>
                    </label>
                  </div>
                </div>
              )}
            </div>
          </form>
        )}
      </OkCancelModal>
    );
  }
}
